import {AssessedPolicy} from './AssessedPolicy';
import {EnabledPolicy} from './EnabledPolicy';

export type Policy = {
  affected: {family: string; platforms: string[]}[];
  assetCount: number;
  benchmarkDescription: string | null;
  benchmarkId: string;
  benchmarkTitle: string;
  consoleOnly?: boolean;
  family: string;
  id: string;
  platforms: string[];
  policyDisplayName: string;
  policyId: string;
  profileDescription: string | null;
  profileId: string;
  profileTitle: string;
  publisher: string;
  replacedBy: string | null; // field to determine if policy is deprecated
  replaces: string[] | null;
  timestamp: number;
  version: string;
  validationStatus: PolicyValidationStatus;
  agentSupported: boolean;
  policyInternalId: string;
  policyTitle: string;
  isEnabled: boolean;
  validationErrorMessage?: string;
};

export enum PolicyValidationStatus {
  PENDING = 'PENDING',
  INVALID = 'INVALID',
  VALID = 'VALID',
}

export type PolicyForm = {
  benchmarkNaturalId: string;
  benchmarkVersion: string;
  profileNaturalId: string;
  isGlobal?: boolean;
};

export type SelectedRule = PolicyForm & {
  ruleNaturalId: string;
};

export type MergedPolicyObject = Policy &
  Partial<AssessedPolicy> &
  Partial<EnabledPolicy> & {
    isCustomPolicy: boolean;
    isBasePolicy: boolean;
    assetCompliance?: number;
    isEnabledPolicy?: boolean;
    isAssessedPolicy?: boolean;
    ruleCompliance?: number;
  };

export enum PolicyDataKey {
  PASSING_ASSETS = 'passingAssets',
  PASSING_FINDINGS = 'passingFindings',
  POLICY_DISPLAY_NAME = 'policyDisplayName',
  POLICY_PUBLISHER = 'publisher',
  ASSESSED_ASSETS = 'assessedAssets',
  ASSESSMENT_SCOPE = 'assessmentScope',
  LAST_AGENT_POLICY_ASSESSMENT_TIME = 'lastAgentPolicyAssessmentTime',
  ASSET_SCOPE_QUERY_ID = 'assetScopeQueryId',
  ASSET_COMPLIANCE = 'assetCompliance',
  RULE_COMPLIANCE = 'ruleCompliance',
  VERSION = 'version',
  TIMESTAMP = 'timestamp',
  IS_ENABLED = 'isEnabledPolicy',
  IS_ASSESSED = 'isAssessedPolicy',
  IS_DEPRECATED = 'isDeprecatedPolicy',
}
